export default function isUndefinedValue(value) {
  return value === undefined || value === null || typeof value === 'string' && value.match(/(undefined|null)/) !== null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/isUndefinedValue.js
// module id = 85
// module chunks = 0